import React, { useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { colors } from '@mui/material';
import { Page, Header } from 'components';
import V1CRReportUpload from './V1CRReport/V1CRReportUpload';
import V1CRTemplate from './V1CRTemplate/V1CRTemplate';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3)
	},
	container: {
		marginTop: theme.spacing(3),
	},
	tabs: {
		marginTop: theme.spacing(3),
	},
	content: {
		marginTop: theme.spacing(3),
	},
	generate: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
}));

const V1CRReport = () => {
	const classes = useStyles();

	return (
		<Page className={classes.root} title="V1CR Report">
			<Header module="V1CR Report" view="V1CR Report" />
			<V1CRTemplate />
			<V1CRReportUpload className={classes.content} />
		</Page>
	);
};

export default V1CRReport;
